import Vue from 'vue'

import * as types from './mutation-types'

export default {
  [types.SET_CASHIER_LIST] (state, cashiers) {
    Vue.set(state, 'cashiers', cashiers)
  }
}
